module.exports = __webpack_public_path__ + "static/media/hardwareMainImg.eb98a59c.png";